let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lMkmS")).then(() => parcelRequire('fIdRw'));